export default __webpack_public_path__ + "static/banner_1800-68806598bf81dc172932dcc5bf49dff0.jpg";